import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { switchMap } from 'rxjs/operators';
import { CheckoutActionTypes } from './actions';

import { AddressesEffects, ReadAddresses } from './addresses';
import { CountriesEffects, ReadCountries } from './countries';
import { OrderEffects } from './order';
import { PaymentEffects } from './payment';
import { ReadPaymentMethods } from './payment-methods';

@Injectable()
export class CheckoutEffects {
  @Effect()
  init$ = this.actions$.pipe(
    ofType(CheckoutActionTypes.INIT),
    switchMap(() => [new ReadAddresses(), new ReadCountries(), new ReadPaymentMethods()])
  );

  constructor(private actions$: Actions) {}
}

export const effects = [AddressesEffects, CountriesEffects, OrderEffects, CheckoutEffects, PaymentEffects];
